module.exports = __webpack_public_path__ + "images/screen-shots/child-profile-91bf3ce2b431534b73ad7539b5ed4ba1.png";